
import React from 'react'
import ReactSelect from 'react-select'

interface Props {    
    label?: string, 
    className?: string, 
    placeholder?: string, 
    onChange: Function, 
    options: Array<object>, 
    value?: object,
    defaultValue?: Array<object>, 
    style?: object
    isClearable?:boolean
}

const MultiSelect = ({
    label=null, 
    className=null, 
    placeholder='', 
    onChange=null, 
    options=[], 
    value=null,
    defaultValue=[], 
    style=null,
    isClearable=true
}:Props ): JSX.Element => {
    return (
        <div className={className ? className : null}>
            {label ? <span> {label} </span> : null}
            <ReactSelect
                multi
                defaultValue={defaultValue}
                placeholder={placeholder}
                onChange={onChange}
                options={options}
                value={value}
                style={style}
                isClearable={isClearable}
                styles={{
                    menu: styles => ({
                        ...styles,
                        margin: '0px',
                        borderRadius: '0px'
                    })
                }}
            />
        </div>
    )
}

export default MultiSelect
